import * as React from 'react';
import { connect } from 'react-redux';

import { Container } from '../../components/Container';

import { IApplicationState } from '../../types/redux';

import { OffersBodyContainer } from './OffersBodyContainer';
import { OffersFooterContainer } from './OffersFooterContainer';
import { OffersHeaderContainer } from './OffersHeaderContainer';
import { SimilarNewbuildings } from './SimilarNewbuildings';
import { INewbuilding } from '../../types/newbuilding';
import { SearchPreloader } from '../../components/SearchPreloader';

interface IOffersStoreProps {
  newbuildings: INewbuilding[];
  isPreloaderVisible: boolean;
}

type TOffersProps = IOffersStoreProps;

const Offers: React.StatelessComponent<TOffersProps> = (props) => {
  const {
    newbuildings = [],
    isPreloaderVisible,
  } = props;

  return (
    <>
      {!!newbuildings.length
        && <Container backgroundColor="white">
          <OffersHeaderContainer />
          <OffersBodyContainer
            newbuildings={newbuildings}
          />
          <OffersFooterContainer />
        </Container>
      }
      <SimilarNewbuildings
        hasNewbuildings={!!newbuildings.length}
      />
      {isPreloaderVisible && <SearchPreloader />}
    </>
  );
};

function mapStateToProps(state: IApplicationState): TOffersProps {
  return {
    newbuildings: state.offersData.newbuildings,
    isPreloaderVisible: state.preloader.isVisible,
  };
}

export const OffersContainer = connect(mapStateToProps)(Offers);
